import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom';
import './styles/index.css'; // moved global index styles into styles/
import './styles/colors.css'; // centralized color variables for CSS
import App from './App'; // Import your main App component

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
    <React.StrictMode>
    <App />
    </React.StrictMode>
);
